export default __webpack_public_path__ + "static/media/section4-img-mob.75e89574.png";